<template>
    <div class="login-body">
        <div class="login-panel p-fluid">
            <div class="login-panel-content">
                <div class="grid">
                    <div class="p-mb-5">
                        <!---->

                        <div class="p-d-flex p-jc-center p-mb-5"><img style="max-width: 20%" src="/assets/logo-highlight-common.svg" alt="yuzaner" /></div>

                        <h3 class="p-d-flex p-jc-center p-mt-2"><span>{{ $store.state.i18n.messageBundle?.auth?.sign_in_title }}</span></h3>

                        <form v-if="isLoginInit" @submit.prevent="onSubmit" class="p-my-5">
                            <div class="p-fluid">
                                <div class="p-my-3">
                                    <p class="p-mb-3">{{ $store.state.i18n.messageBundle?.auth?.sign_in_with_phone_intro }}</p>
                                    <div class="p-my-3">                                    
                                    <div class="p-mb-2">
                                        <label for="phone" class="account-attr-font"><strong>{{ $store.state.i18n.messageBundle?.profile?.phone }}</strong></label>
                                    </div>
                                    <Dropdown
                                        v-model="countryPhoneValue"
                                        :options="countryPhoneValues"
                                        optionLabel="name"
                                        :placeholder="$store.state.i18n.messageBundle?.contact_info?.place_holder?.country_code+' *'"
                                        :filter="true"
                                        :showClear="true"
                                        @change="updateCountryCode()"
                                        class="multiselect-custom p-mr-3"
                                    >
                                        <template #value="slotProps">
                                            <div class="country-item country-item-value" v-if="slotProps.value">
                                                <img alt="flg" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + slotProps.value.code.toLowerCase()" />
                                                <div>{{ slotProps.value.name }}</div>
                                            </div>
                                            <template v-else>
                                                {{ slotProps.placeholder }}
                                            </template>
                                        </template>
                                        <template #option="slotProps">
                                            <div class="country-item">
                                                <img alt="flg" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + slotProps.option.code.toLowerCase()" />
                                                <div>{{ slotProps.option.name }}</div>
                                            </div>
                                        </template>
                                    </Dropdown>
                                    <div class="phone-number-holder">
                                        <InputText style="text-align: right; max-width: 100px;" 
                                            :placeholder="$store.state.i18n.messageBundle?.contact_info?.country_code" v-model="phoneCountryCode" disabled class="p-mt-3 country-code" :class="{ 'p-invalid': v$.phone.$invalid && submitted }" />
                                        <InputText
                                            id="phone"
                                            :placeholder="$store.state.i18n.messageBundle?.contact_info?.place_holder?.phone_number+' *'"
                                            v-model="v$.phone.$model"
                                            :disabled="!phoneCountryCode || phoneCountryCode.length < 1"
                                            type="number"
                                            class="p-mt-3 phone-number-input"
                                            :class="{ 'p-invalid': v$.phone.$invalid && submitted }"
                                        />
                                    </div>
                                    <div>
                                        <small v-if="v$.phone.$invalid && submitted" class="p-error p-mt-3">
                                            {{ $store.state.i18n.messageBundle?.profile?.phone }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>
                                </div>
                                    <div class="p-mb-3"></div>
                                    <div>
                                        <label for="password" class="account-attr-font" :class="{ 'p-error': v$.password.$invalid && submitted }">
                                            <strong>{{ $store.state.i18n.messageBundle?.auth?.password }}</strong></label>
                                        <div class="p-inputgroup">
                                            <InputText id="password" class="password-input-text-corner" 
                                            :placeholder="$store.state.i18n.messageBundle?.auth?.place_holder?.password" maxLength="50" :type="passwordInputType" v-model="v$.password.$model" :class="{ 'p-invalid': v$.password.$invalid && submitted }" />
                                            <Button icon="pi pi-eye" class="input-group-button p-button-info password-input-btn-corner" :disabled="!password" @click="togglePasswordInputType()"/>
                                        </div>
                                    </div>
                                    <div>
                                        <small v-if="v$.password.$invalid && submitted" class="p-error">
                                            {{ $store.state.i18n.messageBundle?.auth?.password }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>
                                </div>
                                
                                <div class="p-my-1">
                                    <Button :disabled="isProcessing || v$.phone.$invalid || v$.password.$invalid || submitted" 
                                    class="p-button-primary" @click="initLogin()" :label="$store.state.i18n.messageBundle?.auth?.sign_in_action"></Button>
                                </div>
                                <div class="p-my-3">
                                    <InlineMessage v-if="isError" severity="error">
                                        {{ errorMsg }}                                        
                                    </InlineMessage>
                                </div>
                            </div>
                        </form>
                        <form v-if="isLoginOtpReq" @submit.prevent="onSubmit" class="p-my-5">
                            <div class="p-fluid">
                                
                                <div class="p-my-3">
                                    <p class="p-mb-3">{{ $store.state.i18n.messageBundle?.auth?.need_to_solve_login_challenge }}</p>
                                </div>
                                
                                <RadioButtonGroup name="channel">
                                    <div v-if="this.otpEmailPrefix" class="p-my-3">
                                        <div class="p-field-checkbox">
                                            <RadioButton inputId="emailChannel" @change="emailChannel()"/>
                                            <label for="emailChannel" :class="{'option-selected': channel==='EMAIL'}">&nbsp;Send to Email</label>
                                        </div>
                                        <div v-if="showOptMaskedEmail">
                                            <span v-if="$store.state.i18n.messageBundle?.label==='mm_MM'"><strong>[{{ otpEmailPrefix }}]</strong>&nbsp;{{ $store.state.i18n.messageBundle?.auth?.otp_email }}</span>
                                            <span v-else>{{ $store.state.i18n.messageBundle?.auth?.otp_email }}&nbsp;<strong>[{{ otpEmailPrefix }}]</strong>.</span>
                                        </div>
                                    </div>  

                                    <div v-if="this.otpPhonePrefix" class="p-my-3">
                                        <div class="p-field-checkbox">
                                            <RadioButton inputId="smsChannel" @change="smsChannel()"/>
                                            <label for="smsChannel" :class="{'option-selected': channel==='SMS'}">&nbsp;Send to Mobile</label>
                                        </div>
                                        <div v-if="showOptMaskedPhone">
                                            <span v-if="$store.state.i18n.messageBundle?.label==='mm_MM'"><strong>[{{ otpPhonePrefix }}]</strong>&nbsp;{{ $store.state.i18n.messageBundle?.auth?.otp_phone }}</span>
                                            <span>{{ $store.state.i18n.messageBundle?.auth?.otp_phone }}&nbsp;&nbsp;<strong>[{{ otpPhonePrefix }}]</strong>.</span>
                                        </div>
                                    </div>   
                                    
                                    <div class="p-my-3">
                                        <div class="p-field-checkbox">
                                            <RadioButton inputId="captchaChannel" @change="captchaChannel()"/>
                                            <label for="captchaChannel" :class="{'option-selected': channel==='CAPTCHA'}" >&nbsp;{{ $store.state.i18n.messageBundle?.auth?.solve_captcha }}</label>
                                        </div>
                                        <div v-if="channel=='CAPTCHA'">
                                            <span>{{ $store.state.i18n.messageBundle?.auth?.solve_captcha_desc }}</span>
                                        </div>
                                    </div>    
                                
                                </RadioButtonGroup>
                                 
                                
                                <div class="p-mt-5 p-mb-1">
                                    <Button :disabled="isProcessing || !channel || submitted" class="p-button-primary" @click="requestOtp()" :label="$store.state.i18n.messageBundle?.common?.proceed"></Button>
                                </div>

                                <div class="p-my-3">
                                    <InlineMessage v-if="isError" severity="error">
                                        {{ errorMsg }}
                                    </InlineMessage>
                                </div>

                                <div v-if="isError" class="p-my-3">
                                    <a class="p-button-link" @click="retryLogin()" >{{ $store.state.i18n.messageBundle?.auth?.retry_login }}</a>
                                </div>
                                
                            </div>
                        </form>
                        <form v-if="isLoginCompletion&&!captchaPhrase" @submit.prevent="onSubmit" class="p-my-5">
                            <div class="p-fluid">

                                <div class="p-my-3">
                                    <p class="p-mb-3">{{ $store.state.i18n.messageBundle?.auth?.enter_otp }}</p>
                                </div>
                                
                                <div class="p-my-3">                                    
                                    <div>
                                        <label for="otp" class="account-attr-font"><strong>OTP</strong></label>
                                        <InputText id="otp" 
                                        :placeholder="$store.state.i18n.messageBundle?.auth?.place_holder?.enter_otp" type="number" v-model="otp" class="common-otp-input otp-input p-mt-2" />
                                    </div>
                                </div>
                                
                                <div class="p-my-1">
                                    <Button :disabled="isProcessing || (otp.length<6)  || submitted" class="p-button-primary" @click="completeLogin()" :label="$store.state.i18n.messageBundle?.common?.submit"></Button>
                                </div>

                                <div class="p-my-3">
                                    <InlineMessage v-if="isError" severity="error">
                                        {{ errorMsg }}
                                    </InlineMessage>
                                </div>
                                <div v-if="isError" class="p-my-3">
                                    <a class="p-button-link" @click="retryLogin()" >{{ $store.state.i18n.messageBundle?.auth?.retry_login }}</a>
                                </div>
                            </div>
                        </form>
                        <form v-if="isLoginCompletion&&captchaPhrase" @submit.prevent="onSubmit" class="p-my-5">
                            <div class="p-fluid">

                                <div class="p-my-3">
                                    <p class="p-mb-3">{{ $store.state.i18n.messageBundle?.auth?.enter_captcha }}</p>
                                </div>
                                
                                <div class="p-my-3">                                    
                                    <div>
                                        <img style="max-height: 50px; width: auto;" class="img-responisve" alt="CAPTCHA" :src="generateCaptchaUrl+'/'+captchaPhrase"/>
                                    </div>
                                    <div>
                                        <label for="captcha" class="account-attr-font"><strong>CAPTCHA</strong></label>
                                        <InputText id="captcha" :placeholder="$store.state.i18n.messageBundle?.auth?.place_holder?.enter_captcha" type="text" v-model="captchaValue" class="common-otp-input otp-input p-mt-2" />
                                    </div>
                                </div>
                                
                                <div class="p-my-1">
                                    <Button :disabled="isProcessing || (captchaValue.length<6)  || submitted" class="p-button-primary" @click="completeLogin()" :label="$store.state.i18n.messageBundle?.common?.submit"></Button>
                                </div>

                                <div class="p-my-3">
                                    <InlineMessage v-if="isError" severity="error">
                                        {{ errorMsg }}
                                    </InlineMessage>
                                </div>
                                <div v-if="isError" class="p-my-3">
                                    <a class="p-button-link" @click="retryLogin()" >{{ $store.state.i18n.messageBundle?.auth?.retry_login }}</a>
                                </div>
                            </div>
                        </form>
                        <hr />
                        <div class="p-mt-3" v-if="isLoginInit">
                            <h5>{{ $store.state.i18n.messageBundle?.common?.useful_links }}</h5>
                            <div class="p-mb-3">
                                <a href="/#/login"><span class="pi pi-sign-in"></span>&nbsp;{{ $store.state.i18n.messageBundle?.auth?.useful_links?.login_with_email }}</a>
                            </div>
                            <div class="p-mb-3">
                                <a class="p-button-link" @click="gotoRegistry()">&nbsp;<span class="pi pi-pen-to-square"></span>&nbsp;{{ $store.state.i18n.messageBundle?.auth?.useful_links?.register_account }}</a>
                            </div>
                            <div class="p-mb-3">
                                <a class="p-button-link" href="/#/reset-password">&nbsp;<span class="pi pi-question"></span>&nbsp;{{ $store.state.i18n.messageBundle?.auth?.useful_links?.forget_password }}</a>
                            </div>
                            <div class="p-mb-3">
                                <a class="p-button-link" @click="gotoShop()">&nbsp;<span class="pi pi-tags"></span>&nbsp;{{ $store.state.i18n.messageBundle?.common?.browse_products }}</a>
                            </div>
                        </div>
                        <div style="padding-bottom: 50px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import AuthService from '../service/AuthService';
import UtilService from '../service/UtilService';
export default {
    authService: null,
    utilService: null,
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            phone: null,
            phoneCountryCode: null,
            countryPhoneValue: null,
            countryPhoneValues: [
                { name: 'Australia', code: 'AU', phoneCountryCode: '+61' },
                //{name: 'China', code: 'CN', phoneCountryCode: '+86'},
                //{name: 'India', code: 'IN', phoneCountryCode: '+91'},
                { name: 'Indonesia ', code: 'ID', phoneCountryCode: '+62' },
                { name: 'Malaysia', code: 'MY', phoneCountryCode: '+60' },
                { name: 'Myanmar', code: 'MM', phoneCountryCode: '+95' },
                { name: 'Philippine', code: 'PH', phoneCountryCode: '+63' },
                { name: 'Singapore', code: 'SG', phoneCountryCode: '+65' },
                { name: 'Thailand', code: 'TH', phoneCountryCode: '+66' },
                //{name: 'Vietnam', code: 'VN', phoneCountryCode: '+84'},
            ],
            password: "",
            passwordInputType: "password",
            showPasswordFlag: false,
            submitted: false,
            isProcessing: false,
            isError: false,
            errorMsg: "",
            defaultErrorMsg: "Cannot login to account! If you forget your login password, you can reset password.",
            otp: "",
            otpChannel: "",
            otpEmailPrefix: "eml******",
            otpPhonePrefix: "123******",
            otpChallenge: "",
            loginChallenge: "",
            captchaPhrase:"",
            captchaValue:"",
            accKey: "",
            channel: "", 
            isLoginInit: true,
            isLoginOtpReq: false,
            isLoginCompletion: false,
            showOptMaskedEmail: false,
            showOptMaskedPhone: false,
            generateCaptchaUrl: process.env.VUE_APP_API_ROOT+'/user/generate-captcha'
        };
    },
    created() {
        this.$store.dispatch('createTitle', process.env.VUE_APP_QUOTE);
        this.authService = new AuthService();
        this.utilService = new UtilService();

        let user = this.$loadUserData(this);
        if (user) {
            this.$gotoProfile(this);
        }
    },
    validations() {
        return {
            phone: {
                required,
            },
            phoneCountrycode: {
                required,
            },
            password: {
                required,
            },
        };
    },
    methods: {
        
        async initLogin() {
            try {
                this.isProcessing = true;
                this.isError = false;
                this.submitted = true;               
                let response = await this.authService.initLoginWithPhone(this.countryPhoneValue.phoneCountryCode.trim(),this.phone.trim(), this.password.trim());
                this.utilService.consoleLog('response:', response);

                this.otpEmailPrefix=response.otpEmailPrefix;
                this.otpPhonePrefix=response.otpPhonePrefix;
                this.otpChallenge=response.otpChallenge;

                let channelExisted= this.otpEmailPrefix||this.otpPhonePrefix;
                
                let toProceedOtpReqFlag = channelExisted&&this.otpChallenge;

                if(!toProceedOtpReqFlag){
                    this.errorMsg = "Error occurred while sending equest!"
                    this.isError = true;
                }else{
                    this.isLoginInit = false;
                    this.isLoginOtpReq = true;
                }

            } catch (err) {
                let errObject = this.utilService.defineError(err);
                this.utilService.consoleLog('errObject:', errObject);
                if (errObject.errorDescription) {
                    this.errorMsg = errObject.errorDescription;
                } else {
                    this.errorMsg = 'Error occurred while processing request! Please try again later.';
                }
                this.isError = true;
            } finally {
                this.isProcessing = false;
                this.submitted = false;
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                });
            }
        },
        async requestOtp() {
            if(this.channel==="CAPTCHA"){
                try{
                    this.otpChannel=this.channel;
                    this.isProcessing = true;
                    this.isError = false;
                    this.submitted = true;
                    
                    //accKey must be already defined in login init operation
                    let response = await this.authService.reqCaptchaLoginWithPhone(this.countryPhoneValue.phoneCountryCode.trim(),this.phone.trim(),this.otpChallenge);
                    this.utilService.consoleLog('response:', response);

                    
                    this.captchaPhrase=response.captchaPhrase;
                    this.loginChallenge=response.loginChallenge;
                    
                    let toProceedLoginConfirmationFlag = this.captchaPhrase&&this.loginChallenge;

                    if(!toProceedLoginConfirmationFlag){                    
                        this.errorMsg = "Error occurred while sending equest!"
                        this.isError = true;
                    }else{
                        this.isLoginInit = false;
                        this.isLoginOtpReq = false;
                        this.isLoginCompletion =true;
                    }
                }catch (err) {
                    let errObject = this.utilService.defineError(err);
                    this.utilService.consoleLog('errObject:', errObject);
                    if (errObject.errorDescription) {
                        this.errorMsg = errObject.errorDescription;
                    } else {
                        this.errorMsg = 'Error occurred while processing request! Please try again later.';
                    }
                    this.isError = true;
                } finally {
                    this.isProcessing = false;
                    this.submitted = false;
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                    });
                }
            }else{
                try {
                    this.otpChannel=this.channel;
                    this.isProcessing = true;
                    this.isError = false;
                    this.submitted = true;
                    
                    //accKey must be already defined in login init operation
                    let response = await this.authService.reqLoginOtpWithPhone(this.countryPhoneValue.phoneCountryCode.trim(),this.phone.trim(), this.otpChannel, this.otpChallenge);
                    this.utilService.consoleLog('response:', response);

                    
                    this.optChannel=response.otpChannel;
                    this.loginChallenge=response.loginChallenge;

                    
                    
                    let toProceedLoginConfirmationFlag = this.optChannel&&this.loginChallenge;

                    if(!toProceedLoginConfirmationFlag){                    
                        this.errorMsg = "Error occurred while sending equest!"
                        this.isError = true;
                    }else{
                        this.isLoginInit = false;
                        this.isLoginOtpReq = false;
                        this.isLoginCompletion =true;
                    }

                } catch (err) {
                    let errObject = this.utilService.defineError(err);
                    this.utilService.consoleLog('errObject:', errObject);
                    if (errObject.errorDescription) {
                        this.errorMsg = errObject.errorDescription;
                    } else {
                        this.errorMsg = 'Error occurred while processing request! Please try again later.';
                    }
                    this.isError = true;
                } finally {
                    this.isProcessing = false;
                    this.submitted = false;
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                    });
                }
            }

            
        },
        async completeLogin() {
            if(this.channel==="CAPTCHA"){
                try {

                    this.isProcessing = true;
                    this.isError = false;
                    this.submitted = true;
                    
                    let response = await this.authService.completeCaptchaLoginWithPhone(
                        this.countryPhoneValue.phoneCountryCode.trim(),this.phone.trim(),
                        this.captchaValue.trim(),
                        this.captchaPhrase.trim(),
                        this.loginChallenge.trim()
                    );
                    this.utilService.consoleLog('response:', response);

                    sessionStorage.setItem('access_token', response.data.access_token);
                    localStorage.setItem('refresh_token', response.data.refresh_token);

                    let profile = await this.authService.fetchAuthUserProfile();

                    this.$saveUserData(this, profile); //save login user info
                    this.$gotoProfile(this); //go to profile page
                } catch (err) {
                    let errObject = this.utilService.defineError(err);
                    this.utilService.consoleLog('errObject:', errObject);
                    if (errObject.errorDescription) {
                        this.errorMsg = errObject.errorDescription;
                    } else {
                        this.errorMsg = 'Error occurred while processing request! Please try again later.';
                    }
                    this.isError = true;
                } finally {
                    this.isProcessing = false;
                    this.submitted = false;
                }    
            }else{
                try {
                    this.isProcessing = true;
                    this.isError = false;
                    this.submitted = true;

                    //accKey must be already defined in login otp request operation
                    //otpChannel must be already defined in login otp request operation
                    //loginChallenge must be already defined in login otp request operation
                    //otp must be populated by intput

                    
                    let response = await this.authService.completeLoginWithPhone(
                        this.countryPhoneValue.phoneCountryCode.trim(),this.phone.trim(),
                        this.otpChannel.trim(),
                        this.loginChallenge.trim(),
                        this.otp.trim()
                    );
                    this.utilService.consoleLog('response:', response);

                    sessionStorage.setItem('access_token', response.data.access_token);
                    localStorage.setItem('refresh_token', response.data.refresh_token);

                    let profile = await this.authService.fetchAuthUserProfile();

                    this.$saveUserData(this, profile); //save login user info
                    this.$gotoProfile(this); //go to profile page
                } catch (err) {
                    let errObject = this.utilService.defineError(err);
                    this.utilService.consoleLog('errObject:', errObject);
                    if (errObject.errorDescription) {
                        this.errorMsg = errObject.errorDescription;
                    } else {
                        this.errorMsg = 'Error occurred while processing request! Please try again later.';
                    }
                    this.isError = true;
                } finally {
                    this.isProcessing = false;
                    this.submitted = false;
                }
            }
            
        },
        retryLogin(){
            this.otp="";
            this.otpChannel= "";
            this.otpEmailPrefix= "";
            this.otpPhonePrefix="";
            this.otpChallenge= "";
            this.loginChallenge="";
            this.captchaPhrase="";
            this.captchaValue="";
            this.accKey= "";
            this.channel= ""; 
            this.isLoginInit= true;
            this.isLoginOtpReq= false;
            this.isLoginCompletion= false;
            this.showOptMaskedEmail= false;
            this.showOptMaskedPhone= false;
            this.submitted= false;
            this.isProcessing= false;
            this.isError= false;
            this.errorMsg= "";
            this.resetForm();
        },
        resetForm() {
            this.email = "";
            this.password = "";
        },
        togglePasswordInputType() {
            if (this.showPasswordFlag) {
                this.showPasswordFlag = false;
                this.passwordInputType = 'password';
            } else {
                this.showPasswordFlag = true;
                this.passwordInputType = 'text';
            }
        },
        gotoShop() {
            this.$gotoShop(this);
        },
        gotoRegistry() {
            this.$gotoAccountRegistry(this);
        },
        emailChannel(){
            this.channel="EMAIL";
            this.showOptMaskedPhone=false;
            this.showOptMaskedEmail=true;
        },
        smsChannel(){
            this.channel="SMS";
            this.showOptMaskedEmail=false;
            this.showOptMaskedPhone=true;
        },
        captchaChannel(){
            this.channel="CAPTCHA";
            this.showOptMaskedEmail=false;
            this.showOptMaskedPhone=false;
        },
        updateCountryCode() {
            if (this.countryPhoneValue) {
                this.phoneCountryCode = this.countryPhoneValue.phoneCountryCode;
            } else {
                this.phoneCountryCode = null;
                this.phone = null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>

.option-selected {
    font-weight: bold;
}

.password-input-text-corner {
    border-radius: 3px 0 0 3px !important; 
    border-width: 1px 0 1px 1px !important;
}

.password-input-btn-corner {
    border-radius: 0 3px 3px 0; 
    border-width: 1px 1px 1px 0; 
    border-color: #65656a;
}

.login-body {
    overflow: hidden;
    position: relative;
    background: url("https://stc-content.ackaya.com/_exp_content/yuzaner/common/images/digital-bg1.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 150vh;
    padding: 0;
    margin: 0;
}

.login-holder {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
a {
    cursor: pointer;
}
a:hover {
    text-decoration: none;
}

.input-group-button {
    margin-top: 0em !important;
    display: block;
    min-width: auto !important;
}

.country-item {
    display: flex;
    align-items: center;
}
.country-item img.flag {
    width: 18px;
    margin-right: 0.5rem;
}

.multiselect-custom .country-placeholder {
    padding: 0.25rem;
}

.p-dropdown {
    width: 100%;
    font-weight: normal;
}

.phone-number-holder {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.country-code {
    width: 25%;
    margin-right: 2px;
}

.phone-number-input {
    width: 75%;
}

.login-body .login-panel {
    background-color: rgba(255, 255, 255, 0.9);
    opacity: .95;
    
}

@media screen and (max-width: 40em) {
    .login-body {
        height: 180vh;
    }

    .login-body .login-panel {
        background-color: rgba(255, 255, 255, 0.9);
        opacity: .95;
        height: 100%;
    }
}
</style>